export enum SmsStatus {
  Delivered = "delivered",
  Failed = "failed",
  FailedRetry = "failed-retry",
  New = "new",
  Queued = "queued",
  Received = "received",
  Sending = "sending",
  Sent = "sent",
  Undelivered = "undelivered",
  Unknown = "unknown",
  ValidationFailed = "validation-failed",
}
